import React from "react";

export const Field = ({ label, children, hint }) => (
  <div>
    <label className="text-xs uppercase tracking-widest" style={{ color: "var(--text-secondary)" }}>{label}</label>
    <div className="mt-2">{children}</div>
    {hint && <p className="mt-1 text-xs" style={{ color: "var(--text-secondary)" }}>{hint}</p>}
  </div>
);

export const inputCls = "w-full rounded-lg border bg-transparent px-4 py-2.5 text-sm outline-none focus:border-[var(--accent-color)] transition-colors";
export const inputStyle = { borderColor: "var(--border-color)" };

export const TextInput = (props) => (
  <input className={inputCls} style={inputStyle} {...props} />
);

export const TextArea = (props) => (
  <textarea className={`${inputCls} min-h-[90px] resize-y`} style={inputStyle} {...props} />
);
